var _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCustomerSatidfaction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 94,
    viewBox: "0 0 95 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_2622_10503)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 47.5,
    cy: 47,
    r: 31,
    fill: "#00C67F",
    fillOpacity: 0.11
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2622_10503)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.5 41.9999C57.5035 40.381 57.1139 38.7854 56.3647 37.3502C55.6155 35.9151 54.5291 34.6833 53.1988 33.7607C51.8684 32.8381 50.334 32.2523 48.7273 32.0536C47.1206 31.8549 45.4897 32.0493 43.9747 32.62C42.4597 33.1907 41.1059 34.1208 40.0297 35.3301C38.9534 36.5395 38.1869 37.9922 37.796 39.5632C37.405 41.1342 37.4013 42.7766 37.7852 44.3494C38.1691 45.9221 38.9292 47.3782 40 48.5924V58.8749C40 59.4636 40.1662 60.0403 40.4796 60.5386C40.793 61.0369 41.2408 61.4366 41.7714 61.6916C42.302 61.9466 42.8939 62.0465 43.4788 61.9798C44.0637 61.9132 44.6178 61.6827 45.0775 61.3149L47.5 59.3749L49.9225 61.3124C50.3819 61.6801 50.9359 61.9105 51.5206 61.9773C52.1052 62.044 52.6969 61.9443 53.2274 61.6896C53.7579 61.4349 54.2057 61.0357 54.5193 60.5377C54.8329 60.0397 54.9995 59.4634 55 58.8749V48.5924C56.6104 46.7739 57.4996 44.4289 57.5 41.9999ZM47.5 34.4999C48.9833 34.4999 50.4334 34.9397 51.6668 35.7639C52.9001 36.588 53.8614 37.7593 54.4291 39.1298C54.9967 40.5002 55.1453 42.0082 54.8559 43.4631C54.5665 44.9179 53.8522 46.2543 52.8033 47.3032C51.7544 48.3521 50.418 49.0664 48.9632 49.3558C47.5083 49.6452 46.0003 49.4966 44.6299 48.929C43.2594 48.3613 42.0881 47.4 41.264 46.1667C40.4398 44.9333 40 43.4832 40 41.9999C40.002 40.0114 40.7928 38.1049 42.1989 36.6988C43.605 35.2927 45.5115 34.5019 47.5 34.4999ZM52.1462 59.4349C52.0405 59.4873 51.9218 59.5081 51.8046 59.4948C51.6873 59.4815 51.5763 59.4346 51.485 59.3599L47.5 56.1711L43.5162 59.3599C43.4245 59.4335 43.3139 59.4798 43.197 59.4933C43.0802 59.5069 42.9619 59.4872 42.8558 59.4366C42.7496 59.3859 42.6599 59.3063 42.597 59.207C42.5341 59.1076 42.5004 58.9925 42.5 58.8749V50.6474C44.0174 51.5331 45.7429 51.9998 47.5 51.9998C49.257 51.9998 50.9825 51.5331 52.5 50.6474V58.8749C52.5014 58.9924 52.4687 59.1078 52.4059 59.2072C52.3432 59.3066 52.253 59.3857 52.1462 59.4349Z",
    fill: "#20435D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_2622_10503",
    x: 0.5,
    y: 0,
    width: 94,
    height: 94,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8,
    result: "effect1_foregroundBlur_2622_10503"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2622_10503"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(32.5 32)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomerSatidfaction);
export default __webpack_public_path__ + "static/media/customer-satidfaction.c4c2bcf8bd844c150a6df21ee9ab3c2d.svg";
export { ForwardRef as ReactComponent };